import styled from 'styled-components';
import { unthemed } from 'tokens';

export const Base = styled.div`
	border-radius: 12px;
	padding-top: 32px;
	margin-bottom: 32px;
`;

export const Content = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	gap: 32px;
`;

export const Left = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 20px;
	flex: 1;
`;

export const UserAvatar = styled.div`
	width: 64px;
	height: 64px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${unthemed.gray[0]};
	font-size: 24px;
	font-weight: 600;
	flex-shrink: 0;
`;

export const Info = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
`;

export const TitleRow = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
`;

export const Title = styled.h1`
	font-size: 32px;
	font-weight: 700;
	color: ${(p) => p.theme.gray[1000]};
	line-height: 1.2;
	margin: 0;
`;

export const EditButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 8px;
	border-radius: 6px;
	background: transparent;
	border: none;
	font-family: inherit;
	transition: all 0.2s ease;

	&:hover {
		background: ${(p) => `${p.theme.blue[400]}1A`};
	}
`;

export const Email = styled.div`
	font-size: 14px;
	color: ${(p) => p.theme.gray[600]};
	user-select: text;
`;

export const ChipWrapper = styled.div`
	margin-top: 8px;
	align-self: flex-start;
`;

export const Right = styled.div`
	display: flex;
	align-items: flex-start;
`;

export const LogoutButton = styled.button`
	display: flex;
	align-items: center;
	gap: 8px;
	padding: 12px 20px;
	background: ${(p) => p.theme.gray[100]};
	color: ${(p) => p.theme.gray[600]};
	font-size: 14px;
	font-weight: 500;
	border: none;
	border-radius: 8px;
	font-family: inherit;
	transition: all 0.2s ease;

	&:hover {
		background: ${(p) => p.theme.gray[200]};
	}
	&:active {
		background: ${(p) => p.theme.gray[400]};
	}
`;
